import { Component, OnInit } from '@angular/core';
import {CollectionService} from "../../services/collection.service";
import {NavigationState} from "../../helpers/navigation-state";
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {IDocument} from "../../interfaces/document.definition";
import {getUtcTime, processTemplateString} from "../../utils";
import {Observable} from "rxjs/Observable";
import {Http, Response} from "@angular/http";
import {PreloaderService} from "../../services/preloader.service";
import {HistoryService} from "../../services/history.service";
import {ErrorService} from "../../services/error.service";
import {ModalService} from "../../services/modal.service";

import {delay, first, repeat, switchMapTo, takeUntil, timeout} from "rxjs/operators";
import {Subject} from "rxjs/Subject";
import {of} from "rxjs/observable/of";
import {timer} from "rxjs/observable/timer";

declare const __metaOut: string[];

@Component({
  selector: 'app-nv-history-journal',
  templateUrl: './nv-history-journal.component.html',
  styles: []
})
export class NvHistoryJournalComponent implements OnInit {

  META_OUT_NAMES = __metaOut;
  ASSETS_POLL_PERIOD = 5000;
  compileAssetsStatus = "";

  nav:NavigationState;
  list:IDocument[] = [];
  meta = { result: ""};

  constructor(private http:Http,
              private preloaderService:PreloaderService,
              private historyService:HistoryService,
              private collectionService:CollectionService,
              private errorService:ErrorService,
              private modalService:ModalService) {
    this.nav =  new NavigationState(() => this.loadList());
    //this.searchController = new SearchController(() => this.loadList());
  }

  ngOnInit() {
    this.loadList();
  }

  getUtcTime(time:number):string
  {
    return new Date(time).toLocaleString();
  }

  onCommonCheckbox(e)
  {
    //console.log(e.target.checked);
    this.list.forEach(
      item => {
        item['selected'] = e.target.checked;
      }
    );
  }

  loadList(){
    let params = paramsHelper.loader()
      .setEndpointId(E_ENDPOINTS.HISTORY)
      .setNavParams(this.nav.offset, this.nav.limit);

    this.collectionService
      .loadChunk(params)
      .subscribe(r => {
        //console.log(r.documents);
        this.list = r.documents;
        this.list.forEach(
          item => {
            item['selected'] = false;
          }
        );
        this.nav.update(r.offset, r.count);
      })
  }

  onExportToGameFileClick() {
    this.preloaderService.show();
    this.sendData("/meta/to-game-file")
        .subscribe(json => {
            this.preloaderService.hide();
            this.meta.result = json;
            this.historyService.addCheckpoint("Выгрузка")
              .subscribe(() => this.loadList());
        });
  }

  onCompileAssets(){
    this.modalService.showConfirm("Уверен, что нужно собрать ассеты?", this.onCompileAssetsConfirmed.bind(this));
  }

  onCompileAssetsConfirmed(){
    this.preloaderService.show();
    //console.log("compile assets");

    this.sendData("/meta/to-game-file").subscribe(json => {
      this.meta.result = json;
      this.historyService.addCheckpoint("Выгрузка").subscribe(() => {
        this.historyService.addCheckpoint("Попытка сборки ассетов").subscribe(() => {
          this.preloaderService.show();
          this.sendData("animations/compile-assets", {}).subscribe(json => {
            console.log(json.message);
            if (json.message == "start") {
              let pollResult = new Subject<void>();
              this.sendGet("animations/compile-assets-poll").pipe(
                repeat(),
                takeUntil(pollResult)
              ).subscribe((resp:Response) => {
                let json = resp.json();
                console.log(json);
                if (json.message == "ok") {
                  console.log("ok");
                  pollResult.next();
                  pollResult.complete();
                  this.historyService.addCheckpoint("Сборка ассетов успешно запущена").subscribe(() => this.loadList());
                }
                else if (json.message == "error") {
                  this.compileAssetsStatus = "Ошибка сборки ассетов!";
                  this.historyService.addCheckpoint(`Ошибка сборки ассетов: ${json.error}`).subscribe(() => this.loadList());
                }
              });
            }
            else if (json.message == "progress") {
              this.compileAssetsStatus = "Сборка ассетов уже в процессе!";
              this.historyService.addCheckpoint("Сборка ассетов уже в процессе!").subscribe(() => this.loadList());
            }
          });
        });
      });
    });
  }

  deleteSelected(){
    this.modalService.showConfirm("Уверен, что нужно это удалять?", this.onDeleteSelectedHistory.bind(this));
  }
  
  onDeleteSelectedHistory(){
    let ids:string[] = [];
    this.list.forEach(
      item => {
        if (item['selected'])
        {
          ids.push(item._id);
        }
      }
    );
    this.historyService.clearHistory(ids)
      .subscribe(() => this.loadList());
  }

  deleteAll(){
    this.modalService.showConfirm("Удаляем прям всю историю?", this.onDeleteAllHistory.bind(this));
  }
  
  onDeleteAllHistory() {
    this.historyService.clearHistory()
      .subscribe(() => this.loadList());
  }

  private sendData(uri:string, data:any = null):Observable<any> {
    return this.http.post(uri, data)
      .map((r:Response) => {
        let j = null;
        try {
          j = r.arrayBuffer().byteLength > 0 ? r.json() : {};
        } catch (e) {
          j = {};
        }
        return j;
      })
      .catch(e => this.errorService.handleError(e));
  }

  private sendGet(url:string): Observable<Response> {
    return this.http.get(url)
      .map((r: Response): Response => {
        return r;
      })
      .catch((e: any): any => this.errorService.handleError(e));
  }

}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-history-journal/nv-history-journal.component.ts